export const api = state => state.api;
export const config = state => state.config;
export const lists = state => state.lists;
export const cluster = state => state.cluster;
export const uuid = state => state.uuid;
export const validation = state => state.validation;
